import styled from "styled-components";

const LastNewsContainer = styled.div`
	/* display: flex; */
`;
export { LastNewsContainer };
